import { Injectable, InjectionToken, inject } from '@angular/core';

export interface IAppConfig {
  version: string;
  envName: string;
  production: boolean;
  backendPythonUrl: string;
  backendNodeUrl: string;
  clientId: string;
  mobile: {
    appleAppId: string;
    appleRedirectURI: string;
    androidClientId: string;
    iosClientId: string;
  };
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  logLevel: number;
  gtm: string;
  posthogApiKey: string;
  posthogApiHost: string;
}

export const APP_CONFIG = new InjectionToken<IAppConfig>('app.config');

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  public config: IAppConfig = inject(APP_CONFIG);
}
